import router from './router'
import { getToken, initUser } from "./utils/token";
import store from './store'

const routerArr = ['/detection', '/MaintenanceHomePage', '/DailycheckHomePage', '/InstallationHomePage', '/SiteHomePage', '/enterprise', '/article', '/facility',
    '/patrolHome','/evaHome','/workTask','/PermissionManagement','/scan'
]

router.beforeEach((to, from, next) => {
    if (navigator.userAgent.match(/(Android)/i)) {
        forApp(to, from, next)  //app使用
    } else if (navigator.isIOS()) {
        forApp(to, from, next)  //app使用
    } else {
        if (to.name != "UstomsInspection") {
            forPc(to, from, next) //pc端使用
        } else {
            next()
        }
    }
    // forPc(to, from, next) //pc端使用
})

function service(next) {
    //加载数据字典
    store.dispatch("loadDictDatas")
    store.dispatch("loadCompanyBox")
    initUser()
    store.dispatch("user/loadUser").then(() => {
        next()
    })
}

function forApp(to, from, next) {
    if (routerArr.indexOf(to.path) != '-1' && from.path == '/') {
        localStorage.removeItem('AndroidToken');
        if (navigator.isAndroid()) {
            $App.openAndroidToken('openAndroidToken')
        } else if (navigator.isIOS()) {
            window.webkit.messageHandlers.getAndroidToken.postMessage("openAndroidToken");
        }
        console.log('等待token');
        
        checkTokenForAPP(next)
    } else {
        console.log('直接跳转');
        
        next()
    }
    // next()
}



function forPc(to, from, next) {
    if (!localStorage.getItem("CT_APP_TOKEN")) {
        getToken().then(() => {
            checkTokenForPC(next)
        }).catch(() => {
            next({
                path: "/UstomsInspection"
            })
        })
    } else {
        checkTokenForPC(next)
    }
}

function checkTokenForAPP(next) {
    if (localStorage.getItem("AndroidToken")) {
        service(next)
    } else {
        setTimeout(() => {
            checkTokenForAPP(next)
        }, 10)
    }
}

function checkTokenForPC(next) {
    if (localStorage.getItem("CT_APP_TOKEN")) {
        service(next)
    } else {
        setTimeout(() => {
            checkTokenForPC(next)
        }, 10)
    }
}
